// do not remove this inclusion. This is required for lead source tracking.

const sbjs = require('sourcebuster');

window.sbjs = sbjs;
